import * as React from "react";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import { match } from "react-router-dom"; //needed for 'location' object and 'match.params'
import { mapDispatchToProps, updateReduxAction } from "../../redux/actions";
import "../../css/FactoryRequests.scss";
import { IOption } from "./MultiSelectDropDown";
import MultiSelectDropDown from "./MultiSelectDropDown";
import { addOneDay, allowedFileExtensions, formatCurrency, formatDate, formatPhone, getBuildingTypeOptions, getStateOptions, needsRecalcRelease, showNeedsRecalcModal } from "./FactoryRequestUtility";
import { isEmptyArray, isNullOrEmpty, resetReduxModals } from "../../utilities/helpers";
import { createFactoryRequest, getSelectedUnitPricingDetails, getUnits, updateProjectInDatabase } from "../../api-calls/projectDataService";
import { updateMultipleUnitPricing } from "../../api-calls/pricingDataService";
import { addNotification } from "../../api-utilities/notification-tools";
import { normalizeBasisOfDesign } from "../../utilities/basisOfDesignOptions";

interface IProps {
  getLogData: () => void;
  match: match<any>;
  updateRedux: any;
  reduxFactoryRequestUnits:any;
  reduxFactoryRequest:any;
  reduxModals:any;
  reduxFactoryRequestLog:any;
  reduxAuth:any;
  reduxProjectManagement:any;
  reduxFactoryRequestBadUnits:any;
  reduxAppVersion:any;
}
interface IState {
    //Expandable Sections
    expandedSections: {
        [key: string]: boolean;
    }
    //Other state
    errors: {
        [key: string]: boolean;
      };
    specialNotes: string;
    selectedPurchaseOrderFile:File | null;
    selectedTaxExemptFile:File | null;
    modifiedUnits:string[];
    disableUI:boolean;
    form: {
      //Shipping  
      willAdviseShippingAddress: string;
      shippingDate: string;
      deliveryDate: string;
      notifyHours: string;
      contactName: string;
      contactPhone: string;
      address1: string;
      address2: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      //Billing
      billToAccount:string;
      purchaseOrderNumber:string;
      taxExempt:string;
      //Project
      consultingEngineer:string;
      contractor:string;
      projectType:string;
      buildingType:string;
      constructionType:string;
      //Compliance
      installInUS:string;
      weapons:string;
      jobCountry:string;
    };
    unitsPricing:any[];
    discountAmount:number;
    //Pricing
    unitMultiplier:number;
    totalNetPriceSubtotal:number;
    totalFreight:number;
    showSubmitTooltip:boolean;
  }
class Release extends React.Component<IProps, IState> {
  public state: IState = {
    expandedSections: {
        shipping: true,
        billing: true,
        project: true,
        compliance: true
      },
    errors: {},
    specialNotes: "",
    modifiedUnits: [],
    selectedPurchaseOrderFile:null,
    selectedTaxExemptFile:null,
    disableUI:false,
    form: {
      //Shipping  
      willAdviseShippingAddress: "No",
      shippingDate: "Next Available",
      deliveryDate:"",
      notifyHours: "",
      contactName: "",
      contactPhone: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      //Billing
      billToAccount:"",
      purchaseOrderNumber:"",
      taxExempt:"",
      //Project
      consultingEngineer:"",
      contractor:"",
      projectType:"",
      buildingType:"",
      constructionType:"",
      //Compliance
      installInUS:"",
      weapons:"",
      jobCountry:""
    },
    unitsPricing:[],
    discountAmount:0,
    //Pricing
    unitMultiplier:0,
    totalNetPriceSubtotal:0,
    totalFreight:0,
    showSubmitTooltip:false
  };
  async componentDidMount(){
    await this.getSelectedUnitPricingDetails();
    this.checkLogStatuses();
    this.calculateTotals();
    this.setState(prev => ({
      form: {
        ...prev.form,
        billToAccount: this.props.reduxAuth.officeId ? this.props.reduxAuth.officeId + " - " + this.props.reduxAuth.officeName : "",
        consultingEngineer: this.props.reduxProjectManagement?.selectedProject?.consultingEngineer ? 
                            this.props.reduxProjectManagement.selectedProject.consultingEngineer : "",
        contractor: this.props.reduxProjectManagement?.selectedProject?.contractor ? 
                            this.props.reduxProjectManagement.selectedProject.contractor : "",
        city: this.props.reduxProjectManagement?.selectedProject?.city ? 
              this.props.reduxProjectManagement.selectedProject.city : "",
        projectType: this.props.reduxProjectManagement?.selectedProject?.projectType ? 
              this.props.reduxProjectManagement.selectedProject.projectType : "",
        purchaseOrderNumber: this.props.reduxProjectManagement?.selectedProject?.purchaseOrderNumber ? 
                            this.props.reduxProjectManagement.selectedProject.purchaseOrderNumber : "",
        state: this.props.reduxProjectManagement?.selectedProject?.state ? 
              this.props.reduxProjectManagement.selectedProject.state : "",
        constructionType: this.props.reduxProjectManagement?.selectedProject?.constructionType ? 
                  this.props.reduxProjectManagement.selectedProject.constructionType : "",
      }
    }));
    await this.getPricingDetails();

    //Pricing has been run, so we need to refresh the units so that the updated RecalcFlag
    //will be in redux.
    const { projectId, unitId } = this.props.match.params;
    //Get list of units for this project and store in redux.
    const response = await getUnits("proj-" + projectId);
    const unitList = response.unitList != null ? response.unitList : [];
    store.dispatch(updateReduxAction("UPDATE_FACTORY_REQUEST_UNITS", unitList));
  }
  componentDidUpdate(prevProps: IProps, prevState: IState){
    const modal = this.props.reduxModals;

    //If submittal modal state changed from open to closed
    if (prevProps.reduxModals.showModal !== modal.showModal && modal.showModal === false) {
      //If the modal that just closed was the 'submit-factory-request' modal, and the user response was 'ok'
      if (modal.modalId === 'submit-release-modal' && modal.userResponse.response === 'ok') {
        //Save the design basis that the user selected in the release modal.
        this.updateProject(modal.userResponse.designBasis);
        this.submitReleaseRequest();
      }
      //Only reset the modal if the id is 'submit-factory-request'
      if (modal.modalId === 'submit-release-modal') {
        resetReduxModals();
      }
    }
    //Has user changed selected units.
    if (this.state.modifiedUnits.length !== prevState.modifiedUnits.length ||
        this.state.modifiedUnits.every((value, index) => value === prevState.modifiedUnits[index]) === false){
       this.calculateTotals();
    }
  }
  private async getSelectedUnitPricingDetails(){
    const { projectId, unitId } = this.props.match.params;

    //Get list of units for this project and store in redux.
    const response = await getSelectedUnitPricingDetails("proj-" + projectId);
    if (!response.hasError ){
        if (response.unitsSummaryPricing && response.unitsSummaryPricing.length > 0){
            this.setState({ unitsPricing: response.unitsSummaryPricing });
        }
        this.setState({discountAmount: Math.abs(response.discountAmount)});
    }
  }
  private async updateProject(designBasis: string){
    let selectedProject = { ...this.props.reduxProjectManagement.selectedProject};
    selectedProject.designBasis = normalizeBasisOfDesign(designBasis);

    //Call the project data service method to update project data.
    const response = await updateProjectInDatabase(selectedProject);
  }
  private async submitReleaseRequest() {
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: true });
    const r = this.state.form;

    //unitList is used to get the UnitTags
    const unitList = (store.getState() as any).reduxFactoryRequestUnits;

    let units = this.convertModifiedUnits(unitList);
    let requestObject = {
      ProjectId: this.props.reduxFactoryRequest.factoryRequest.ProjectId,
      RequestType: this.props.reduxFactoryRequest.factoryRequest.RequestType,
      RequestId: this.props.reduxFactoryRequest.factoryRequest.RequestId,
      AppVersion: isNullOrEmpty(this.props.reduxAppVersion.appVersion) ? "0" : this.props.reduxAppVersion.appVersion,
      SelectedUnits: units,
      ReleaseRequestDetails: {
        ShippingDateType: r.shippingDate ?? "",
        RequestedDeliveryDate: r.deliveryDate === "" ? null : r.deliveryDate,
        NotifyCustomerHours: r.notifyHours ? Number(r.notifyHours) : 0,
        WillAdviseShippingAddress: r.willAdviseShippingAddress === "Yes" ? true : false,
        ContactName: r.contactName ?? "",
        ContactPhoneNumber: r.contactPhone ?? "",
        AddressLine1: r.address1 ?? "",
        AddressLine2: r.address2 ?? "",
        City: r.city ?? "",
        StateRegion: r.state ?? "",
        ZipPostalCode: r.zip ?? "",
        CountryRegion: r.country ?? "",
        SpecialNotes: this.state.specialNotes ?? "",
        BillToAccount: r.billToAccount ?? "",
        PurchaseOrderNumber: r.purchaseOrderNumber ?? "",
        IsTaxExempt: r.taxExempt === "Yes" ? true :  false,
        ConsultingEngineer: r.consultingEngineer ?? "",
        Contractor: r.contractor ?? "",
        ProjectType: r.projectType ?? "",
        BuildingType: r.buildingType ?? "",
        ConstructionType: r.constructionType ?? "",
        IsFinalInstallUS: r.installInUS === "Yes" ? true : false,
        GoodsUsedForWeapons: r.weapons === "Yes" ? true : false,
        JobCountry: r.jobCountry ?? "",
      }
    }
    await this.updateProjectInfo();
    
    const factoryRequestResponse = await createFactoryRequest(requestObject, null, this.state.selectedPurchaseOrderFile, this.state.selectedTaxExemptFile);

    if (factoryRequestResponse.success && !factoryRequestResponse.data.hasError) {
    //      //1. Disable Release submit somehow.
    }
    
    this.props.getLogData();
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: false });
    this.setState({disableUI:true});

  }
  private async updateProjectInfo(){
    let selectedProject = { ...this.props.reduxProjectManagement.selectedProject};
    selectedProject.consultingEngineer = this.state.form.consultingEngineer;
    selectedProject.contractor = this.state.form.contractor;
    selectedProject.city = this.state.form.city;
    selectedProject.buildingType = this.state.form.buildingType;
    selectedProject.constructionType = this.state.form.constructionType;
    selectedProject.projectType = this.state.form.projectType;
    selectedProject.purchaseOrderNumber = this.state.form.purchaseOrderNumber;
    selectedProject.state = this.state.form.state;
    this.props.updateRedux("UPDATE_PROJECT_MANAGEMENT", {selectedProject: selectedProject});
    //Call the project data service method to update project data.
    await updateProjectInDatabase(selectedProject);    
  }
  private toggleSection = (section: string) => {
    this.setState(prev => ({
      expandedSections: {
        ...prev.expandedSections,
        [section]: !prev.expandedSections[section]
      }
    }));
  };
  private handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    if (name === "installInUS"){
        //installInUs is set to "yes". 1)Update jobCountry to "USA" 2)Remove jobCountry from validation errors since it's been populated.
        if (value === "Yes"){
          this.setState(prev => ({
              form: {
                ...prev.form,
                jobCountry: "USA"
              }
            }));
          this.setState(prev => {
             const updatedErrors = { ...prev.errors };
             delete updatedErrors['jobCountry'];
          
             return { errors: updatedErrors };
          });
        }
        //installInUs is set to "no". 1)Update jobCountry to "Choose" 2)Add jobCountry to validation errors since it's not populated.
        if (value === "No"){
          this.setState(prev => ({
            form: {
              ...prev.form,
              jobCountry: ""
            }
          }));
          this.setState(prev => {
            const updatedErrors = { ...prev.errors };
            updatedErrors.jobCountry = true;
         
            return { errors: updatedErrors };
         });
        }
    }
    if (name === "specialNotes") {
      this.setState({ specialNotes: value });
    } else {
      this.setState(prev => ({
        form: {
          ...prev.form,
          [name]: value
        }
      }));
    }
    
    this.setState(prev => {
        const updatedErrors = { ...prev.errors };
        delete updatedErrors[name];
        return { errors: updatedErrors };
      });
  };
  private handleNumberChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    // Remove non-digits
    const onlyNumbers = value.replace(/\D/g, '');
    this.setState(prev => ({
       form: {
         ...prev.form,
         [name]: onlyNumbers
      }
    }));
    this.setState(prev => {
        const updatedErrors = { ...prev.errors };
        delete updatedErrors[name];
        return { errors: updatedErrors };
      });
  }
  private handlePhoneChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;
    const formatted = formatPhone(value);
    this.setState(prev => ({
        form: {
          ...prev.form,
          [name]: formatted
        }
      }));
    this.setState(prev => {
      const updatedErrors = { ...prev.errors };
      delete updatedErrors[name];
      return { errors: updatedErrors };
    });
  }
  private handleUnitSelectionChange (id:number, selected:string[])  {
    this.setState({modifiedUnits:selected})
    this.setState(prev => {
      const updatedErrors = { ...prev.errors };
      delete updatedErrors["modifiedUnits"];
      return { errors: updatedErrors };
    });
  }
  private getGrandTotal() {
    return this.state.totalNetPriceSubtotal + this.state.totalFreight - this.state.discountAmount;
  }
  public render() {
    const { expandedSections, specialNotes, form, errors } = this.state;
    const unitOptions = this.getUnitOptions();
    const elementClass = this.state.disableUI ? "element-disable" : "";
    //get the minimum selectable date as tomorrow.
    const minDate = formatDate(addOneDay(new Date()));
    const disableField = this.state.form.willAdviseShippingAddress === "Yes" ? true : false;
    const pricingUnits = this.filterPricingUnitsWithSelected();
    const enablePricingButton = pricingUnits.some((u:any) => u.reCalcLevel !== "None" && u.reCalcLevel !== "WeightCalcOnly");
    
    return (
      <>
      <div className="price-container">
        {/* Price button in case we want to bring it back */}
        {/* <button
            className={enablePricingButton ? "recalc-pricing-btn" : "element-disable recalc-pricing-btn"}
            type="button"
            onClick={() => this.runPricing()}
        >
            Update Pricing
        </button> */}
      <div className="price-table-container">

        <table className="unit-table">
            <thead className="pricing-table-header">
                <tr className="pricing-header-row">
                    <th>Tag</th>
                    <th>Model</th>
                    <th className="price-column">Unit List Price</th>
                    <th className="price-column">Multiplier</th>
                    <th className="price-column">Unit Net Price</th>
                </tr>
            </thead>
            <tbody>
                {this.renderUnitPricingRows()}
            </tbody>
        </table>
        <div className="pricing-summary">
        <div className="pricing-summary-row">
            <span>Job Net Price</span>
            <span>{formatCurrency(this.state.totalNetPriceSubtotal)}</span>
        </div>

        <div className="pricing-summary-row">
            <span>Freight</span>
            <span>{formatCurrency(this.state.totalFreight)}</span>
        </div>
        {this.state.discountAmount != undefined && this.state.discountAmount != null && this.state.discountAmount > 0 && 
        (<div className="pricing-summary-row">
            <span>Discount</span>
            <span className="negative">
            ({formatCurrency(this.state.discountAmount)})
            </span>
        </div>)}
        <div className="pricing-summary-row grand-total">
            <span>Grand Total</span>
            <span>{formatCurrency(this.getGrandTotal())}</span>
        </div>
        </div>
      </div>
      </div>
      <div className="form-container">
        {/* UNITS */}
        <div className="units-dropdown">
            <label className="unit-label-release">Units</label>
            <MultiSelectDropDown
                className={errors.modifiedUnits ? "input-required-error" : this.state.disableUI ? "element-disable" : ""}
                options={unitOptions}
                onChange={(id:number, selected:string[]) => this.handleUnitSelectionChange(id, selected)}
                initialSelected={this.state.modifiedUnits || []}
                modificationId={0}
                includeAll={true}
                titleText={"Select Units to be released to production"}
            />   
        </div>
        
        <div className="required-fields">* Required Fields</div>
        {/* SHIPPING INFORMATION */}
        <div
            className={"section-header "  + elementClass}
            onClick={() => this.toggleSection("shipping")}
            >
            <span>Shipping Information</span>
            <span className={expandedSections.shipping ? "arrow arrow-open": "arrow"}/>
        </div>

        {expandedSections.shipping && (
          <div className="section-body">

            <div className="form-row">
              <label>Shipping Date *</label>
              <select
                name="shippingDate"
                value={form.shippingDate}
                onChange={this.handleChange}
              >
                <option>Next Available</option>
                <option>Delayed Delivery</option>
              </select>
            </div>

            {this.state.form.shippingDate === "Delayed Delivery" ? (
            <div className="form-row">
                <label className="label-width">Requested Delivery Date *</label>
                <input
                    className={errors.deliveryDate ? "input-required-error" : ""}
                    name="deliveryDate"
                    type="date"
                    value={form.deliveryDate}
                    min={minDate}
                    onKeyDown={(e) => e.preventDefault()}//Does not allow manually editing the date.
                    onChange={this.handleChange}
                />
            </div>    
            ) : null}

            <div className="form-row">
              <label>Notify Customer Prior to Delivery (hours) *</label>
              <input
                className={errors.notifyHours ? "input-required-error" : ""}
                name="notifyHours"
                value={form.notifyHours}
                onChange={this.handleNumberChange}
                placeholder="1-99"
                maxLength={2}
              />
            </div>

            <div className="form-row">
              <label>Will Advise Shipping Address *</label>
                <select
                    name="willAdviseShippingAddress"
                    value={form.willAdviseShippingAddress}
                    onChange={this.handleChange}
                >
                    <option>No</option>
                    <option>Yes</option>
                </select>
            </div>

            <div className="form-row">
              <label>Contact Name *</label>
              <input className={disableField ? "input-disable": errors.contactName ? "input-required-error" : "" }
                name="contactName"
                value={form.contactName}
                onChange={this.handleChange}
                maxLength={35}
              />
            </div>

            <div className="form-row">
              <label>Contact Phone Number *</label>
              <input className={disableField ? "input-disable": errors.contactPhone ? "input-required-error" : "" }
                name="contactPhone"
                value={form.contactPhone}
                onChange={this.handlePhoneChange}
                placeholder="###-###-####"
                inputMode="numeric"
              />
            </div>

            <div className="form-row">
              <label>Country/Region *</label>
              <select className={disableField ? "input-disable": errors.country ? "input-required-error" : "" }
                name="country"
                value={form.country}
                onChange={this.handleChange}
              >
                  <option value="" disabled>Choose</option>
                  <option>USA</option>
                  <option>Canada</option>
                  <option>Mexico</option>
                  <option>Puerto Rico</option>
                  <option>Guam</option>
              </select>
            </div>

            <div className="form-row">
              <label>Address Line 1 *</label>
              <input className={disableField ? "input-disable": errors.address1 ? "input-required-error" : "" }
                name="address1"
                value={form.address1}
                onChange={this.handleChange}
                maxLength={35}
              />
            </div>
            <div className="form-row">
              <label>Address Line 2</label>
              <input className={disableField ? "input-disable":""}
                name="address2"
                value={form.address2}
                onChange={this.handleChange}
                maxLength={35}
              />
            </div>

            <div className="form-row">
              <label>City *</label>
              <input className={disableField ? "input-disable": errors.city ? "input-required-error" : "" }
                name="city"
                value={form.city}
                maxLength={50}
                onChange={this.handleChange}
              />
            </div>
            <div className="form-row">
              <label>State/Province *</label>
              <select className={disableField ? "input-disable": errors.state ? "input-required-error" : "" }
                name="state"
                value={form.state}
                onChange={this.handleChange}
              >
                <option value="" disabled>Choose</option>
                {getStateOptions(this.state.form.country)}
              </select>
            </div>

            <div className="form-row">
              <label>Zip/Postal Code *</label>
              <input className={disableField ? "input-disable": errors.zip ? "input-required-error" : "" }
                name="zip"
                value={form.zip}
                maxLength={5}
                onChange={this.handleNumberChange}
              />
            </div>

            <div className="form-row">
              <label>Special Notes</label>
              <textarea
                name="specialNotes"
                value={specialNotes}
                maxLength={500}
                onChange={this.handleChange}
                placeholder="Up to 500 characters"
              />
            </div>
            <div className="char-counter">
              {500 - specialNotes.length} characters remaining
            </div>
            </div>
        )}

        {/* BILLING INFORMATION */}
        <div
            className={"section-header "  + elementClass}
            onClick={() => this.toggleSection("billing")}
            >
            <span>Billing Information</span>
            <span className={expandedSections.billing ? "arrow arrow-open" : "arrow" } />
        </div>
        {expandedSections.billing && (
          <div className="section-body">
            <div className="form-row">
                <label>Bill To Account</label>
                <input 
                name="billToAccount"
                disabled={true}
                value={form.billToAccount}
                maxLength={50}
                onChange={this.handleChange}
                />
            </div>
            <div className="form-row">
                <label>Purchase Order# *</label>
                <input 
                    className={errors.purchaseOrderNumber ? "input-required-error" : ""}
                    name="purchaseOrderNumber"
                    value={form.purchaseOrderNumber}
                    maxLength={50}
                    onChange={this.handleChange}
                />
            </div>
            {/* PURCHASE ORDER FILE UPLOAD */}
            <div className="form-row">
                <label>Upload Purchase Order *</label>
                <input
                    type="file"
                    id="fileUploadPO"
                    accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.step,.dwg"
                    style={{ display: "none" }}
                    onChange={(e) => this.handleFileChange("selectedPurchaseOrderFile", e)}
                />
                <button
                    className={errors.selectedPurchaseOrderFile ? "input-required-error" : ""}
                    type="button"
                    onClick={() => document.getElementById("fileUploadPO")?.click()}
                >
                    Upload File
                </button>
                {this.state.selectedPurchaseOrderFile && (
                    <span className="display-file">
                        {this.state.selectedPurchaseOrderFile.name}
                    </span>
                )}
            </div>
            <div className="form-row">
              <label>Is Equipment being supplied to or installed at an entity that qualifies as Tax Exempt? *</label>
                <select
                    className={errors.taxExempt ? "input-required-error" : ""}
                    name="taxExempt"
                    value={form.taxExempt}
                    onChange={this.handleChange}
                >
                    <option value="" disabled>Choose</option>
                    <option>Yes</option>
                    <option>No</option>
                </select>
            </div>
            {/* TAX EXEMPT FILE UPLOAD */}
            <div className={form.taxExempt === "Yes" ? "form-row" : "form-row app-display-none"}>
                <label>Upload Tax Exemption Certificate</label>
                <input
                    type="file"
                    id="fileUploadTE"
                    accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.step,.dwg"
                    style={{ display: "none" }}
                    onChange={(e) => this.handleFileChange("selectedTaxExemptFile", e)}
                />
                <button
                    type="button"
                    onClick={() => document.getElementById("fileUploadTE")?.click()}
                >
                    Upload File
                </button>
                {this.state.selectedTaxExemptFile && (
                    <span className="display-file">
                        {this.state.selectedTaxExemptFile.name}
                    </span>
                )}
            </div>
          </div>
        )}
        {/* PROJECT INFORMATION */}
        <div
            className={"section-header "  + elementClass}
            onClick={() => this.toggleSection("project")}
            >
            <span>Job Information</span>
            <span className={expandedSections.project ? "arrow arrow-open" : "arrow" } />
        </div>
        {expandedSections.project && (
           <div className="section-body">
           <div className="form-row">
               <label className="label-width">Consulting Engineer</label>
               <input
                   name="consultingEngineer"
                   value={form.consultingEngineer}
                   onChange={this.handleChange}
                   maxLength={50}
               />
           </div>    
           <div className="form-row">
               <label className="label-width">Contractor</label>
               <input
                   name="contractor"
                   value={form.contractor}
                   onChange={this.handleChange}
                   maxLength={50}
               />
           </div>    
           <div className="form-row">
               <label>Project Type *</label>
               <select
                   className={errors.projectType ? "input-required-error" : ""} 
                   name="projectType"
                   value={form.projectType}
                   onChange={this.handleChange}
               >
                   <option value="" disabled>Choose</option>
                   <option>Plan & Spec</option>
                   <option>Design Build/Assist</option>
                   <option>Other</option>
               </select>
           </div>
           <div className="form-row">
               <label>Construction Type *</label>
               <select
                   className={errors.buildingType ? "input-required-error" : ""} 
                   name="buildingType"
                   value={form.buildingType}
                   onChange={this.handleChange}
               >
               <option value="" disabled>Choose</option>
               {getBuildingTypeOptions()}
               </select>
           </div>
           <div className="form-row">
               <label>Job Type *</label>
               <select
                   className={errors.constructionType ? "input-required-error" : ""} 
                   name="constructionType"
                   value={form.constructionType}
                   onChange={this.handleChange}
               >
                   <option value="" disabled>Choose</option>
                   <option>New Construction</option>
                   <option>Remodel</option>
                   <option>Replacement</option>
               </select>
           </div>
       </div>
        )}

        {/* COMPLIANCE INFORMATION */}
        <div
            className={"section-header "  + elementClass}
            onClick={() => this.toggleSection("compliance")}
            >
            <span>Compliance</span>
            <span className={expandedSections.compliance ? "arrow arrow-open" : "arrow" } />
        </div>
        {expandedSections.compliance && (
          <div className="section-body">
            <div className="form-row">
                <label>Is final installation of product(s) in the United States *</label>
                <select
                    className={errors.installInUS ? "input-required-error" : ""}
                    name="installInUS"
                    value={form.installInUS}
                    onChange={this.handleChange}
                >
                    <option value="" disabled>Choose</option>
                    <option>Yes</option>
                    <option>No</option>
                </select>
            </div>
            <div className="form-row">
                <label>Will goods be used in the development, production, or use of chemical, biological, or nuclear weapons or for missiles 
                    capable of delivering weapons? *</label>
                <select
                    className={errors.weapons ? "input-required-error" : ""}
                    name="weapons"
                    value={form.weapons}
                    onChange={this.handleChange}
                >
                    <option value="" disabled>Choose</option>
                    <option>Yes</option>
                    <option>No</option>
                </select>
            </div>
            <div className="form-row">
              <label>Country/Region *</label>
              <select className={errors.jobCountry ? "input-required-error" : ""}
                name="jobCountry"
                value={form.jobCountry}
                onChange={this.handleChange}
              >
                  <option value="" disabled>Choose</option>
                  <option>USA</option>
                  <option>Canada</option>
                  <option>Mexico</option>
                  <option>Puerto Rico</option>
                  <option>Guam</option>
              </select>
            </div>
          </div>
        )}
        <div className="release-button">
        {/* Submit Button */}
        <div className="submit-button-wrapper"
                  onMouseEnter={() => this.setState({ showSubmitTooltip: this.showSubmitToolTip() })}
                  onMouseLeave={() => this.setState({ showSubmitTooltip: false })}
                >
          <button
              className={"factory-submit-button " + elementClass}
              onClick={() => this.validateAndSubmitRelease()}
          >
              Submit
          </button>
            {this.state.showSubmitTooltip && (
              <div className="submit-tooltip">
                {this.getSubmitToolTipText()}
              </div>
            )}
        </div>
        <span className={Object.keys(errors).length === 0 ? "app-display-none" : "input-error-display"}>Required fields missing</span>
        </div>
      </div>
      </>
    );
  }
  private checkLogStatuses(){
    //If there are any factory requests that are not complete(5) or cancelled(6),
    //then disable the UI.
    const requestLogs = this.props.reduxFactoryRequestLog;
    
    const hasAnyInProgress = requestLogs.some((log:any) => 
      (log.statusId !== 5 && log.statusId !== 6) || log.requestType === "Release" 
    );
    if (hasAnyInProgress){
        this.setState({
            expandedSections: {
              shipping: false,
              billing: false,
              project: false,
              compliance: false
            }
          });
    }
    if (this.state.disableUI !== hasAnyInProgress){
        this.setState({disableUI:hasAnyInProgress});
    }
  }
  private validateFields(){
    const v = this.state.form;
    const errors: any = {};
    if (v.willAdviseShippingAddress !== "Yes"){
        if (!v.notifyHours.trim()) errors.notifyHours = true;
        if (!v.contactName.trim()) errors.contactName = true;
        if (!v.contactPhone.trim()) errors.contactPhone = true;
        if (!v.address1.trim()) errors.address1 = true;
        if (!v.city.trim()) errors.city = true;
        if (!v.state.trim()) errors.state = true;
        if (!v.country.trim()) errors.country = true;
        if (!v.zip.trim()) errors.zip = true;
    }
    if (v.shippingDate === "Delayed Delivery"){
        if (!v.deliveryDate.trim()) errors.deliveryDate = true;
    }
    if (!v.purchaseOrderNumber.trim()) errors.purchaseOrderNumber = true;
    if (this.state.selectedPurchaseOrderFile === null) errors.selectedPurchaseOrderFile = true;
    if (!v.taxExempt.trim()) errors.taxExempt = true;
    if (!v.projectType.trim()) errors.projectType = true;
    if (!v.buildingType.trim()) errors.buildingType = true;
    if (!v.constructionType.trim()) errors.constructionType = true;
    if (!v.installInUS.trim()) errors.installInUS = true;
    if (!v.weapons.trim()) errors.weapons = true;
    if (!v.jobCountry.trim()) errors.jobCountry = true;
    if (this.state.modifiedUnits.length === 0) errors.modifiedUnits = true;
    this.setState({ errors });

    return Object.keys(errors).length === 0;
  }
  private getSubmitToolTipText(){
    const log = this.props.reduxFactoryRequestLog;
    //If a release request has been submitted, never allow the submit button to be enabled.
    const releaseCount = log.filter((item:any) => item?.requestType === "Release").length;
    if (releaseCount > 0){
      return `This project has been released and modification requests are no longer allowed. 
      For change orders or cancellations to the project, please contact your RSM.`;
    }
    const hasAnyInProgress = log.some((log:any) => 
      (log.statusId !== 5 && log.statusId !== 6) 
    );
    if (hasAnyInProgress){
      return `Submit is unavailable until the previous modification request is completed or canceled.`;
    }
  }
  private showSubmitToolTip(){
    const log = this.props.reduxFactoryRequestLog;

    return log.some((item: any) =>
      item?.requestType === "Release" ||
      (item.statusId !== 5 && item.statusId !== 6)
    );
  }
  private validateAndSubmitRelease() {
    const mods = this.state.modifiedUnits;
    const allUnits = this.props.reduxFactoryRequestUnits;
    //Find units that are either FullReCalc or FullUnitStructureRebuild.
    const recalcUnits = needsRecalcRelease(mods, allUnits);
    if (recalcUnits.length !== 0) {
      //One of the units selected is either FullReCalc or FullUnitStructureRebuild.
      //Show model and return;
      showNeedsRecalcModal(recalcUnits);
      return;
    }
    const valid = this.validateFields();
    if (valid){
        this.showSubmitRequestModal();
    }
  }
  private showSubmitRequestModal(){
  //This triggers ModalContainer.tsx to open the modal
  store.dispatch(
    updateReduxAction("UPDATE_MODALS", {
      showModal: true,
      modalType: "SubmittalReleaseModal",
      modalData: "",
      modalId: "submit-release-modal"
    })
  );
  }
  private getUnitOptions() {
    const unitOptions: IOption[] = this.props.reduxFactoryRequestUnits
      .filter((u: any) => u.isActive)   // only active units
      .map((u: any) => ({
        name: u.unitTag,
        value: u.id
      }));
  
    return unitOptions;
  }
  //This builds a lookup table using the unitList in reduxProjectManagement.  It uses the unitId to find the unitTag.
  //May need to add to this for OpportunityProductId
  private buildUnitLookup(unitList: any[]) {
    return unitList.reduce((acc: Record<string, string>, unit: any) => {
      acc[unit.id] = unit.unitTag;
      return acc;
    }, {});
  }
  //ModifiedUnits is an array of unit Ids.  We need to convert this array to include a unitId and UnitTag property
  //for each item.  If the user selected "All" units, then every unit in the project would be included.
  //useAll is passed in as true for running pricing.
  private convertModifiedUnits(unitList: any[], useAll:boolean = false) {
    const unitLookup = this.buildUnitLookup(unitList);
    
    let units = useAll ? ["All"] : this.state.modifiedUnits;
      const includesAll = units.includes("All");
  
      let convertedUnits;
  
      if (includesAll) {
        // Include every unit from the lookup
        convertedUnits = Object.keys(unitLookup).map(unitId => ({
          UnitId: unitId,
          UnitTag: unitLookup[unitId]
        }));
      } else {
        convertedUnits = units.map((unitId: string) => ({
          UnitId: unitId,
          UnitTag: unitLookup[unitId] || null
        }));
      }
  
      return convertedUnits;
  }
  private calculateTotals() {
    const filteredUnits = this.filterPricingUnitsWithSelected();
    const seenUnitIds = new Set();
    const totals = filteredUnits.reduce(
      (acc: any, unit: any) => {
        const isNewUnit = !seenUnitIds.has(unit.unitID);

        if (unit.reCalcLevel === "None" || unit.reCalcLevel === "WeightCalcOnly") {
          acc.totalNetPriceSubtotal += unit.unitIndividualNetPrice || 0;
          if(isNewUnit) acc.totalFreight += unit.freight || 0;
          seenUnitIds.add(unit.unitID);
        }
  
        return acc;
      },
      {
        totalNetPriceSubtotal: 0,
        totalFreight: 0,
      }
    );
  
    this.setState(totals);
  }
  private filterPricingUnitsWithSelected(){
    let units:any[];
    if (this.state.modifiedUnits.includes("All")){
      //Only show active units for pricing.
      units = this.state.unitsPricing.filter((u:any) => u.isActive !== false);
    }
    else {
      units = this.state.unitsPricing.filter((u:any) => this.state.modifiedUnits.includes(u.unitID));
    }
    return units;
  }
  private async getPricingDetails(){
    await this.getSelectedUnitPricingDetails();
    this.calculateTotals();
  }
  // runPricing = async () => {
  //   //unitList is used to get the UnitTags
  //   const unitList = (store.getState() as any).reduxFactoryRequestUnits;
  //   console.log(unitList);
  //   let units = this.convertModifiedUnits(unitList, true);
  //   const unitIds: string[] = units.map(u => u.UnitId);
    
  //   const { projectId, unitId } = this.props.match.params;
  //   this.props.updateRedux("UPDATE_DISPLAY", { showLoader: true });

  //   let priceResponse = await updateMultipleUnitPricing(projectId, unitIds);
    
  //   await this.getSelectedUnitPricingDetails();
    
  //   this.props.updateRedux("UPDATE_DISPLAY", { showLoader: false });

  //   if (priceResponse.hasError){
  //     const hasIndividualErrors = !isEmptyArray(priceResponse.individualErrors);

  //     const notification = {
  //       id: "updateMultiplePricing",
  //       notificationType: "error",
  //       title: hasIndividualErrors ? "Pricing Errors" : "Pricing Error",
  //       content: (
  //         <div className="nf-div">
  //           {hasIndividualErrors
  //             ? priceResponse.individualErrors.toString()
  //             : priceResponse.errorMessage?.toString()}
  //         </div>
  //       )
  //     };
  //     addNotification(notification);
  //   }
  //   this.calculateTotals();
  // }
  private renderUnitPricingRows() {
    const units = this.filterPricingUnitsWithSelected();
    
    return units.map((unit: any, index:number) => (
        <tr className="pricing-table-row" key={index}>
          <td>{unit.unitTag}</td>
          <td>{unit.modelNumber}</td>
          <td className="price-column">
            {unit.reCalcLevel === "None" || unit.reCalcLevel === "WeightCalcOnly" ?
            unit.unitIndividualListPrice.toLocaleString("en-US", {
              style: "currency",
              currency: "USD"
            }) : "-"}
          </td>
          <td className="price-column">{unit.unitMultiplier}</td>
          <td className="price-column">
          {unit.reCalcLevel === "None" || unit.reCalcLevel === "WeightCalcOnly" ?
            unit.unitIndividualNetPrice.toLocaleString("en-US", {
              style: "currency",
              currency: "USD"
            }) : "-"}
          </td>
        </tr>
      ));
  }
  //FILE ACTIONS
  private handleFileChange = (stateName:string, e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
  
      const file = e.target.files[0];
      const extension = "." + file.name.split(".").pop()?.toLowerCase();
  
      if (!allowedFileExtensions.includes(extension)) {
        const notification = {
          id: "invalidfiletype",
          notificationType: "warning",
          title: "Invalid File Type",
          content: <div className="nf-div">This file is not allowed: {file.name}.  Allowed Types({allowedFileExtensions.join(", ")})</div>
        };
        addNotification(notification);
        return;
      }
  
      this.setState({
        [stateName]: file
      } as any);
    }
    this.setState(prev => {
      const updatedErrors = { ...prev.errors };
      delete updatedErrors[stateName];
      return { errors: updatedErrors };
    });
  };
}
 
//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
    return {
      reduxFactoryRequestUnits: state.reduxFactoryRequestUnits,
      reduxFactoryRequest: state.reduxFactoryRequest,
      reduxModals: state.reduxModals,
      reduxFactoryRequestLog: state.reduxFactoryRequestLog,
      reduxAuth: state.reduxAuth,
      reduxProjectManagement: state.reduxProjectManagement,
      reduxFactoryRequestBadUnits: state.reduxFactoryRequestBadUnits,
      reduxAppVersion: state.reduxAppVersion
    };
  }
  export default connect(mapStateToProps, mapDispatchToProps)(Release);

